import {useEffect} from 'react';
import {connect, useSelector} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import * as loaderNames from '../../../consts/loader/loaderNames';
import ModalTypes from '../../../enums/app/modalTypes';
import modalService from '../../../services/modalService';
import productService from '../../../services/product/productService';
import {hideLoader} from '../../../state/ducks/global';
import {showDeviceHolderRegistrationModalAction} from '../../../state/ducks/modal';
import {makeSelectIotDeviceMergedWithConsumerProduct} from '../../../state/selectors/consumer';
import {
    selectIsScpCheckInProgress,
    selectIsSkipRegistration,
    selectIsStartAutoSync,
} from '../../../state/selectors/global';
import {selectIsDeviceReady} from '../../../state/selectors/iotDevice';
import {makeSelectVisibleGlobalModal} from '../../../state/selectors/modal';
import {makeSelectIsYapDeviceInfoReceived} from '../../../state/selectors/yapEncrypted';
import {dispatch} from '../../../state/store';

const mapStateToProps = createStructuredSelector({
    iotProduct: makeSelectIotDeviceMergedWithConsumerProduct(),
    isDeviceReady: selectIsDeviceReady,
    isYapDeviceInfoReceived: makeSelectIsYapDeviceInfoReceived(),
    isScpCheckInProgress: selectIsScpCheckInProgress,
    isStartAutoSync: selectIsStartAutoSync,
    isSkipRegistration: selectIsSkipRegistration,
});

const DeviceHolderRegistrationChecker = ({
    iotProduct,
    isDeviceReady,
    isYapDeviceInfoReceived,
    isScpCheckInProgress,
    isStartAutoSync,
    isSkipRegistration,
}) => {
    const {device, holder} = iotProduct || {};
    const {isHolderConnected} = device || {};
    const {status: holderStatus, deviceSerialNumber} = holder || {};
    const isHolderRegistering = productService.getIsRegistering(holderStatus);
    const isHolderRegistered = productService.getIsRegistered(holderStatus);
    const isVisiblePurchaseDateModalPopup = useSelector(makeSelectVisibleGlobalModal(ModalTypes.PURCHASE_DATE));
    const isVisibleManualRegPopup = useSelector(makeSelectVisibleGlobalModal(ModalTypes.MANUAL_REGISTRATION));

    const isShowHolderRegModal =
        deviceSerialNumber &&
        !isScpCheckInProgress &&
        isHolderConnected &&
        isDeviceReady &&
        isYapDeviceInfoReceived &&
        isStartAutoSync &&
        !isVisiblePurchaseDateModalPopup &&
        !isVisibleManualRegPopup &&
        !isHolderRegistering &&
        !isHolderRegistered &&
        !isSkipRegistration;

    useEffect(() => {
        if (isShowHolderRegModal) {
            dispatch(showDeviceHolderRegistrationModalAction());
        } else {
            if (!isHolderConnected) {
                dispatch(hideLoader(loaderNames.REGISTERING_LOADER));
            }
            modalService.hideModal(ModalTypes.PURCHASE_DATE);
            modalService.hideModal(ModalTypes.REGISTRATION_HOLDER);
        }
    }, [isShowHolderRegModal]);

    return null;
};

export default connect(mapStateToProps)(DeviceHolderRegistrationChecker);
